import React, { useState } from "react";
import { validation } from "../../utils/validation";
import { useSesion } from "../../context/System/SesionContext";
import HcorzLoader from "../layout/HCorzLoader";
import HcorzAlert from "../layout/HcorzAlert";

import logo from "../../img/logo.png";

const Login = () => {
  const {
    loginForm,
    handleChangeLoginForm,
    handleSubmitLoginForm,
  } = useSesion();

  const [buttonLogin, setButtonLogin] = useState(false);
  const [errors, setErrors] = useState({ username: "", password: "" });

  const handleSubmit = (e) => {
    e.preventDefault();
    setButtonLogin(true);
    const valid = validation(loginForm);
    setErrors(valid);

    if (Object.keys(valid).length === 0) {
      handleSubmitLoginForm(e);
    } else {
      // Optional: Show alert only if needed, or rely on inline errors
      // alert("Usuario o contraseña inválidos");
    }
  };

  return (
    <section className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-black relative overflow-hidden">
      {/* Background Decorative Elements */}
      <div className="absolute top-[-10%] left-[-10%] w-1/2 h-1/2 bg-amber-500/10 rounded-full blur-[120px]"></div>
      <div className="absolute bottom-[-10%] right-[-10%] w-1/2 h-1/2 bg-indigo-500/10 rounded-full blur-[120px]"></div>

      <div className="w-full max-w-md p-8 relative z-10">
        {/* Glass Card */}
        <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl shadow-2xl p-8 transform transition-all hover:scale-[1.01] duration-500">

          {/* Logo / Header */}
          <div className="text-center mb-8">
            <img
              src={logo}
              alt="Logo"
              className="h-16 mx-auto mb-4 drop-shadow-lg rounded-xl"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
            <h1 className="text-3xl font-bold bg-gradient-to-r from-amber-200 to-yellow-500 bg-clip-text text-transparent tracking-tight">
              Bienvenido
            </h1>
            <p className="text-gray-400 text-sm mt-2">Sistema de Gestión Integral</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <label className="text-gray-300 text-xs font-semibold uppercase tracking-wider ml-1">Usuario</label>
              <div className="relative group">
                <input
                  type="text"
                  name="username"
                  placeholder="Ingrese su usuario"
                  value={loginForm.username?.value || ""}
                  onChange={handleChangeLoginForm}
                  className={`w-full bg-gray-900/50 border ${errors.username ? 'border-red-500' : 'border-gray-700 group-hover:border-amber-500/50'} focus:border-amber-500 text-white rounded-xl px-4 py-3 outline-none transition-all placeholder-gray-600`}
                />
                <div className={`absolute inset-0 rounded-xl pointer-events-none transition-all duration-300 ${errors.username ? 'shadow-[0_0_15px_rgba(239,68,68,0.2)]' : 'group-hover:shadow-[0_0_15px_rgba(245,158,11,0.1)]'}`}></div>
              </div>
              {errors.username && <p className="text-red-400 text-xs ml-1 flex items-center gap-1"><span className="inline-block w-1 h-1 rounded-full bg-red-400"></span>{errors.username}</p>}
            </div>

            <div className="space-y-2">
              <label className="text-gray-300 text-xs font-semibold uppercase tracking-wider ml-1">Contraseña</label>
              <div className="relative group">
                <input
                  type="password"
                  name="password"
                  placeholder="••••••••"
                  autoComplete="on"
                  value={loginForm.password?.value || ""}
                  onChange={handleChangeLoginForm}
                  className={`w-full bg-gray-900/50 border ${errors.password ? 'border-red-500' : 'border-gray-700 group-hover:border-amber-500/50'} focus:border-amber-500 text-white rounded-xl px-4 py-3 outline-none transition-all placeholder-gray-600`}
                />
                <div className={`absolute inset-0 rounded-xl pointer-events-none transition-all duration-300 ${errors.password ? 'shadow-[0_0_15px_rgba(239,68,68,0.2)]' : 'group-hover:shadow-[0_0_15px_rgba(245,158,11,0.1)]'}`}></div>
              </div>
              {errors.password && <p className="text-red-400 text-xs ml-1 flex items-center gap-1"><span className="inline-block w-1 h-1 rounded-full bg-red-400"></span>{errors.password}</p>}
            </div>

            <button
              type="submit"
              className="w-full bg-gradient-to-r from-amber-600 to-yellow-600 hover:from-amber-500 hover:to-yellow-500 text-white font-bold py-3.5 rounded-xl shadow-lg shadow-amber-900/20 transform transition-all active:scale-[0.98] hover:shadow-amber-500/20 mt-4"
            >
              Iniciar Sesión
            </button>
          </form>

          <div className="mt-8 text-center">
            <p className="text-gray-600 text-xs">© 2025 ATECMA. Todos los derechos reservados.</p>
          </div>
        </div>
      </div>

      <HcorzAlert />
      <HcorzLoader />
    </section>
  );
};

export default Login;
